// TODO: This might need to move
export enum DefaultChartColorScales {
	'Single Color' = 'Single Color',
	Categorical = 'Categorical',
	Sequential = 'Sequential',
}

export const DefaultCategoricalColors = [
	'#7d9968', // moss
	'#d73b41', // red
	'#e66f00', // orange
	'#0093ff', // blue
	'#9d79ff', // purple
	'#f3598c', // pink
	'#8d9980', // olive
	'#b9874b', // gold
	'#2d9db5', // teal
	'#7487fe', // indigo
	'#00a657', // green
	'#c470d3', // violet
	'#d27869', // salmon
];
